module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "interact"
  }, [(_vm.article) ? _c('media-container', {
    attrs: {
      "issue": _vm.article,
      "figures": _vm.article.files.figures
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', [_vm._v("Interact with this Article")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ff9b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/InteractPage.vue
// module id = 1404
// module chunks = 1